<script setup lang="ts">
import type { FieldSchema } from '../../../types';

defineOptions({ inheritAttrs: false });

defineProps<{
  field?: FieldSchema;
  text?: string;
}>();
</script>

<template>
  <p class="mb-3 w-full whitespace-pre-line border-s-2 border-gray-300 pl-2 text-sm text-gray-600">
    {{ field?.text || text }}
  </p>
</template>
